import { Components, Theme } from '@mui/material/styles';

const MuiTypography: Components<Theme>['MuiTypography'] = {
  styleOverrides: {
    gutterBottom: {
      marginBottom: 8,
    },
  },
};

export default MuiTypography;
